// extracted by mini-css-extract-plugin
module.exports = {"checkboxEstrangeiro":"CadastroClienteEvento_checkboxEstrangeiro__2Krtj"};